jQuery(document).ready(function ($) {

    var module_name = 'anchor_menu';
    module_name = '.' + module_name.replace(/_/g, '-') + '-module';

    // Add active class for current page
    var url = window.location.href;
    var hash = window.location.hash;

    $(module_name + ' a').each(function () {
        if ($(this).attr('href') == url) {
            $(this).parent().find('a').addClass('active');
        } else if ($(this).attr('href') == hash) {
            $(this).parent().find('a').addClass('active');
        }
    });

    // Add active class on click
    $(module_name + ' a').click(function () {
        $(this).parent().parent().find('a').removeClass('active');
        $(this).addClass('active');
    });

    // Animate
    $(module_name + ' a.anchor').on('click', function (e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: $($(this).attr('href')).offset().top - 60
        });
    });

    if ($('.swiper-container.sticky').length) {
        var top = $(module_name + ' .sticky').offset().top;

        $(window).scroll(function () {
            var y = $(this).scrollTop();
            if (y >= top) {
                $(module_name).addClass('fixed');
            } else {
                $(module_name).removeClass('fixed');
            }
        });
    }
});